import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucLoHangTruyXuatNguonGocPhuongThucSanXuat } from 'src/app/shared/DanhMucLoHangTruyXuatNguonGocPhuongThucSanXuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucLoHangTruyXuatNguonGocPhuongThucSanXuatService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "DanhMucLoHangTruyXuatNguonGocPhuongThucSanXuat";
    }
}

